import { useMemo } from 'react';

import { UnitTour } from '../../types/Unit/Unit';
import getResourcePath from '../../utils/getResourcePath/getResourcePath';
import UnitListDTO from '../../types/UnitListDTO/UnitListDTO';
import useFetch from '../useFetch/useFetch';
import useURLParam, { UnitListURLParam } from '../useURLParam/useURLParam';

const useUnitTours = () => {
    const resourcePath = getResourcePath();
    const { data, error, loading } = useFetch<UnitListDTO>(resourcePath);

    const showActiveUnitsOnly =
        useURLParam(UnitListURLParam.showActiveOnly) === 'true';

    const unitTours = useMemo<UnitTour[]>(() => {
        if (!data) {
            return [];
        }

        const conditionallyFilterActiveUnits = (unitTour: UnitTour) =>
            showActiveUnitsOnly ? unitTour.active === true : true;

        /*
            There's a business requirement to show all the unmatched tours
            if no matched ones with PMS were found.
         */
        if (!data.units || data.units.length === 0) {
            return data.unMatchedTourBuilderTours
                .map((unit) => ({
                    ...unit.unitTour,
                    numBath: Number(unit.unitTour.numBath),
                    numBed: Number(unit.unitTour.numBed),
                    // We want to have link to this tour when there is no PMS integration
                    // so we need to get _id manually and assign to tour property which is used
                    // in table columns config.
                    tour: unit._id,
                }))
                .filter(conditionallyFilterActiveUnits);
        }

        return data.units
            .filter(conditionallyFilterActiveUnits)
            .map((unit) => ({
                ...unit,
                numBath: Number(unit.numBath),
                numBed: Number(unit.numBed),
            }));
    }, [data, showActiveUnitsOnly]);

    return { data: unitTours, error, loading };
};

export default useUnitTours;
